<template>
  <div>
    <PageTitle title="Troca de Turma" />
    <div v-if="$featureToggle && $featureToggle.INTEGRA_MENU_TROCATURMA">
      <div v-show="!modalTrocaTurma">
        <md-toolbar id="md-toolbar-page" md-elevation="0" class="md-dense" style="background-color: inherit">
          <div class="toolbar-left">
            <md-field style="width: 200px">
              <label for="font">Período</label>
              <md-select v-model="periodo">
                <md-option value="Todos">Todos</md-option>
                <md-option :value="(c ? c : '')" v-for="(c, index) in periodos" :key="index">
                  {{c}}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="toolbar-right">
            <md-button class="md-text-and-icon md-outlined md-primary md-dense" @click="modalTrocaTurma = true;">
              <md-icon>playlist_add</md-icon>Trocar turma
            </md-button>
          </div>
        </md-toolbar>
        <Loading v-bind:show="showLoading">
          <GridLinha v-if="dadosAba"
                     v-bind:Data="dadosFiltrados"
                     :key="dataKey"
                     v-bind:Header="headerAtivos"
                     Name="trocaturma"
                     Title="trocaturma" />
          <div style="text-align:center;margin-top:15px">
            <span v-if="dadosAba && dadosAba.historicoTrocaTurma && dadosAba.length == 0">{{msgErro ? msgErro : "Nenhum dado encontrado."}}</span>
          </div>
        </Loading>
      </div>
      <div v-show="modalTrocaTurma">
        <Adicionar 
                   :aluno="aluno" 
                   :dadosAba="dadosAba"
                   @fechar="modalTrocaTurma = false; carregar();"/>
      </div>
    </div>
    <span v-else class="s-h3 regular">Funcionalidade desabilitada temporariamente</span>
  </div>
</template>
<script>
  import Loading from '@/components/Loading';
  import GridLinha from '@/components/GridLinha';
  import PageTitle from '@/components/PageTitle';
  import Adicionar from './Adicionar';

  import TrocaTurmaService from '@/services/TrocaTurmaService.js';

  export default {
    components: {
      Loading,
      GridLinha,
      PageTitle,
      Adicionar
    },
    data() {
      return {
        aluno: null,
        dadosAba: null,
        showLoading: false,
        modalTrocaTurma: false,
        periodo: "Todos",
        dataKey: 1,
        headerAtivos: [
          { Titulo: "Período", Field: "codigoPeriodo", Width: "120px", Tipo: "texto" },
          { Titulo: "Data da troca", Field: "dataMudancaTurma", Width: "120px", Tipo: "date" },
          { Titulo: "Turma origem", Field: "turmaOrigem", Width: "120px", Tipo: "texto" },
          { Titulo: "Turma destino", Field: "turmaDestino", Width: "120px", Tipo: "texto" },
          { Titulo: "Motivo", Field: "motivo", Tipo: "texto" },
        ],
      }
    },
    computed: {
      periodos() {
        if (this.dadosAba?.historicoTrocaTurma) {
          let periodos = [...new Set(
            this.dadosAba.historicoTrocaTurma.map(
              item => item.codigoPeriodo
            )
          )];

          return periodos.sort().reverse();
        }

        return [];
      },

      dadosFiltrados() {
        let dados = [];

        if (this.dadosAba?.historicoTrocaTurma) {

          if (typeof (this.periodo) == "string" && this.periodo.toUpperCase() == "TODOS") {
            dados = this.dadosAba.historicoTrocaTurma;
          }
          else
            dados = this.dadosAba.historicoTrocaTurma.filter((el) => {
              return (el.codigoPeriodo === null ? "" : el.codigoPeriodo) == this.periodo;
            });
        }

        return dados;
      }
    },
    beforeDestroy() {
      let aluno = JSON.parse(sessionStorage.Aluno);

      //Armazena os dados da aba pra nao precisar carregar novamente
      aluno.TrocaTurma = this.dadosAba;
      sessionStorage.setItem("Aluno", JSON.stringify(aluno));
    },
    created() {
      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {

        this.trocaTurmaService = new TrocaTurmaService(this);

        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
          //Verifica se os dados da Aba ja esta carregado
          if (a.TrocaTurma) {
            this.dadosAba = a.TrocaTurma;
          }
          else
            this.dadosAba = this.carregar();
        }
        else
          this.$router.push('home');
      }
    },
    methods: {
      carregar() {
        this.showLoading = true;
        this.trocaTurmaService.ObterTrocaTurma({
          CodigoAluno: this.aluno.codigoAluno,
          CodigoEmpresa: this.aluno.codigoEmpresa
        }).then(
          data => {
            if (data.ok) {
              this.dadosAba = data.dados;
            }
            else {
              this.$modal.info(data.Mensagem);
            }
          },
          error => {
            if (error.status != 500)
              this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
            else
              this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
          }).finally(() => {
            this.showLoading = false;
          });
      }
    }
  }
</script>